<form [formGroup]="theForm" novalidate [@formState]="state">
  <mat-dialog-content style="width: 480px">
    <h1>{{ 'turbo.dialog.changePassword.title' |translate: 'Change password' }}</h1>
    <t4-container title="">
      <div>

        <div class="row" *ngIf="state != 'success'">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.dialog.changePassword.currentPassword' |translate:'Current password'}}</mat-label>
              <mat-icon matPrefix>lock_outline</mat-icon>
              <input matInput required type="password" formControlName="oldPassword">
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.dialog.changePassword.newPassword' | translate:'New password'}}</mat-label>
              <mat-icon matPrefix>lock_outline</mat-icon>
              <input matInput required type="password" formControlName="newPassword">
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.dialog.changePassword.confirmPassword' |translate:'Confirm password'}}</mat-label>
              <mat-icon matPrefix>lock_outline</mat-icon>
              <input matInput required type="password" formControlName="confirmPass" (keyup.enter)="changePassword()">
              <mat-error *ngIf="theForm.controls['confirmPass'].hasError('notEquivalent')">
                {{ 'turbo.dialog.changePassword.confirmPasswordError' |translate:'Passwords does not match'}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div class="validationError" *ngIf="validation.passwordIncorrect">
            {{ 'turbo.dialog.changePassword.msgPasswordNotCorrect' |translate:'Old password is incorrect'}}
          </div>
        </div>
        <div class="confirmationMessage" *ngIf="state == 'success'">
          {{ 'turbo.dialog.changePassword.msgPasswordChanged' |translate:'The password has been changed'}}
        </div>
      </div>
    </t4-container>
  </mat-dialog-content>
  <mat-dialog-actions style="width: 446px" *ngIf="state != 'success'">
    <button mat-raised-button color="primary" style="width: 432px;" (click)="changePassword()" [disabled]="isWorking">{{ 'turbo.dialog.changePassword.cmdConfirm' |translate:'Change password'}}</button>
  </mat-dialog-actions>
</form>
<mat-progress-bar mode="indeterminate" *ngIf="isWorking"></mat-progress-bar>
